// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const KYC_BIZUM_LOADER_PROPS = {
    altText: 'loading',
    animation: 'animation_loader_secondary',
    size: VARIANTS.ThirdPartyAnimationSizesType.MEDIUM,
  },
  KYC_BIZUM_FIRST_DESCRIPTION_PROPS = {
    dataTestId: 'kyc-bizum-description-01',
  },
  KYC_BIZUM_SECOND_DESCRIPTION_PROPS = {
    dataTestId: 'kyc-bizum-description-02',
  };

export {
  KYC_BIZUM_LOADER_PROPS,
  KYC_BIZUM_FIRST_DESCRIPTION_PROPS,
  KYC_BIZUM_SECOND_DESCRIPTION_PROPS,
};
